import React from 'react'

import StepContainer from 'components/Tour/StepContainer'

const steps = [
  {
    selector: '',
    content: ({ goTo, step }) => (
      <StepContainer
        goTo={goTo}
        nextStep={step}
        title="Bienvenido"
        description="Te guiaremos por los campos importantes de este formulario de información fiscal."
      />
    )
  },
  {
    selector: '[data-tour="fiscal-rfc"]',
    content: ({ goTo, step }) => (
      <StepContainer
        goTo={goTo}
        nextStep={step}
        title="RFC"
        description="Registro Federal del contribuyente, para integración de expediente y como parte de los requisitos de la Ley de Prevención de Lavado de Dinero."
      />
    )
  },
  {
    selector: '[data-tour="fiscal-curp"]',
    content: ({ goTo, step }) => (
      <StepContainer
        goTo={goTo}
        nextStep={step}
        title="CURP"
        description="La Clave Única de Registro de Población, para integración de expediente y generación de contrato."
      />
    )
  },
  {
    selector: '[data-tour="fiscal-beneficiarios"]',
    content: ({ goTo, step, close }) => (
      <StepContainer
        isLastStep
        onClose={close}
        goTo={goTo}
        nextStep={step}
        title="Beneficiarios"
        description="Es necesaria la asignación de mínimo 1 o máximo 3 personas como beneficiarios en caso de muerte del titular de la cuenta, estos beneficiarios serán quienes reciban comisiones pendientes de cobro (de transacciones o de red)."
      />
    )
  }
]

export default steps
